import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-play",
  "use": "icon-play-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1024 1024\" id=\"icon-play\">\n<path d=\"M815.4,364.9c-181.2-98-290.3-196-471.5-294c-181.2-98-271.8-49-271.8,147v588c0,196,90.6,245,271.8,147\n\tc181.2-98.1,290.3-196,471.5-294C996.6,560.9,996.6,462.9,815.4,364.9L815.4,364.9z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol